import { buildDeerMeta } from "./deerMappings";

/**
 * Transform EEM measures data to Gantt chart tasks format
 * @param {Array} eemMeasures - Array of EEM measure objects from API
 * @returns {Array} - Array of tasks in Gantt format
 */
export const transformEemToTasks = (eemMeasures) => {
  if (!eemMeasures || !Array.isArray(eemMeasures)) {
    return [];
  }


  const defaultYear = 2025;

  return eemMeasures.map((measure, index) => {
    // Set all measures to start on January 1st of the configured default year
    const startDate = new Date(defaultYear, 0, 1); // January 1st of default year

    // End date: December 31st of default year (or can be customized)
    const endDate = new Date(defaultYear, 11, 31); // December 31st of default year

    // Use sequential IDs starting from 1 to ensure uniqueness and compatibility
    const id = measure.id;
    const description = measure.ecmDescription || measure.description || measure.name || measure.title || 'No description';
    const descriptionLine = String(description).replace(/\s+/g, " ").trim();
    const progress = measure.progress || measure.completion || 0;
    const categoryValue =
      measure.doeCategory ??
      measure.ecmCategory ??
      measure.category ??
      measure.ecmCategoryId;
    const subCategoryValue =
      measure.doeSubCategory ??
      measure.ecmSubCategory ??
      measure.subCategory ??
      measure.ecmSubCategoryId;
    const { categoryLabel, subCategoryLabel, barMeta } = buildDeerMeta(
      categoryValue,
      subCategoryValue
    );
    const task = {
      id: id,
      start: startDate,
      end: endDate,
      text: descriptionLine,
      progress: progress,
      parent: 0, // All are parent items for now
      type: "task",
      measureDisplayIndex: index + 1,
      details: descriptionLine,
      barDescription: descriptionLine,
      barMeta,
      categoryLabel,
      subCategoryLabel,
      originalMeasure: measure, // Store complete original EEM measure data
    };

    if (index === 0) {
    }

    return task;
  });
};

/**
 * Update task parent when grouping is created
 * @param {Array} tasks - Current tasks array
 * @param {number} childId - ID of task to be made a child
 * @param {number} parentId - ID of parent task
 * @returns {Array} - Updated tasks array
 */
export const outenchusupdateTaskParent = (tasks, childId, parentId) => {
  return tasks.map(task => {
    if (task.id === childId) {
      return { ...task, parent: parentId };
    }
    if (task.id === parentId && task.type !== 'summary') {
      return { ...task, type: 'summary', open: true };
    }
    return task;
  });
};
